import React, { Component } from "react"
import PropTypes from "prop-types"

import moment from "moment"
import { startCase } from "lodash/string"
import { isKeyClick } from "../../scripts/utils"
import { dispatch } from "../../Dispatcher"

import { FormattedMessage, injectIntl } from "react-intl"
import { getStyles } from "../../styles/dynamicStyles"
import searchMessages from "../../messages/search"
import classnames from "classnames"
import AccordiItem from "../elements/AccordiTab/AccordiItem"
import Calendar from "../elements/Calendar"

class FilterDate extends Component {
  static propTypes = {
    name: PropTypes.string,
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string
  }

  handleFromDateChange = moment => {
    dispatch({
      type: "search-date-range",
      name: this.props.name,
      from: moment ? moment.format("YYYY-MM-DD") : null
    })
  }

  handleDateFromClear = () => {
    this.handleFromDateChange()
  }

  handleToDateChange = moment => {
    // RC-Calendar creates its own input and doesn't expose this input anywhere
    // https://github.com/react-component/calendar/blob/ebd5eec43b24e1a29219b4edfb039baf135483c8/src/date/DateInput.js#L55

    // This code is to override the default of 01/01/YEAR and replace it with 31/12/YEAR
    // There are two "rc-calendar-input"s on the page, fromDate and toDate
    const inputs = document.getElementsByClassName("rc-calendar-input")
    const numberOfInputs = inputs.length

    const toDateInputValue =
      numberOfInputs > 0 && inputs[numberOfInputs - 1].value
    // Having found the raw value of the "toDate",

    toDateInputValue.length === 4 ? moment.month(11).date(31) : null
    // if it matches the format of YYYY (./elements/Calendar ln.28)
    // set the date to 31/12/YEAR

    dispatch({
      type: "search-date-range",
      name: this.props.name,
      to: moment ? moment.format("YYYY-MM-DD") : null
    })
  }

  handleDateToClear = () => {
    this.handleToDateChange()
  }

  render() {
    const { name, dateFrom, dateTo, intl } = this.props

    //dates
    const momentFrom = dateFrom ? moment(dateFrom) : null
    const momentTo = dateTo ? moment(dateTo) : null
    const dateFilterFrom = dateFrom
      ? momentFrom.format("Do MMM, YYYY")
      : intl.formatMessage(searchMessages.filterStatusAgesAgo)
    const dateFilterTo = dateTo
      ? momentTo.format("Do MMM, YYYY")
      : intl.formatMessage(searchMessages.filterStatusToday)
    const dateFilterStatusText =
      dateFrom || dateTo
        ? intl.formatMessage(searchMessages.filterStatusTo, {
            dateFrom: dateFilterFrom,
            dateTo: dateFilterTo
          })
        : null

    return (
      <AccordiItem
        title={
          <span
            href="#"
            className="c-results-filters__head"
            style={getStyles("c-results-filters__head")}
          >
            {startCase(name)} <small>{dateFilterStatusText}</small>
          </span>
        }
        expandedClassName="date-filters-exanded"
        expanded={!!(dateFrom || dateTo)}
        className={classnames({
          "state-filter-active": !!(dateFrom || dateTo),
          "state-filter-inactive": !dateFrom && !dateTo
        })}
        id="date-filters"
      >
        <div id="calendar-dom-hook" />
        <ul
          className="c-results-filters__list menu vertical nested"
          style={getStyles("c-results-filters__list")}
        >
          <li
            className="c-results-filters__single-block"
            style={getStyles("c-results-filters__single-block")}
          >
            <label
              htmlFor="searchDateFrom"
              style={getStyles("search-date-from__label")}
            >
              <FormattedMessage {...searchMessages.from} />
            </label>
            <div
              className="row"
              style={getStyles("c-results-filters__single-block__row")}
            >
              <div
                className="date-input--input small-10 columns"
                style={getStyles("date-input--input")}
              >
                <Calendar
                  name="searchDateFrom"
                  value={momentFrom}
                  onChange={this.handleFromDateChange}
                  placeholder={intl.formatMessage(searchMessages.dateDDMMYY)}
                />
              </div>
              <div
                className="date-input--action small-2 columns"
                style={getStyles("date-input--action")}
              >
                <button
                  type="button"
                  style={getStyles("date-input--action__button")}
                  className="button button--alert-subtle button--square-small"
                  onKeyPress={e =>
                    isKeyClick(e) ? this.handleDateFromClear(e) : null
                  }
                  onClick={this.handleDateFromClear}
                  title={intl.formatMessage(searchMessages.buttonClearDate)}
                >
                  ×
                </button>
              </div>
            </div>

            <label
              htmlFor="searchDateTo"
              style={getStyles("search-date-from__label")}
            >
              <FormattedMessage {...searchMessages.to} />
            </label>
            <div
              className="row"
              style={getStyles("c-results-filters__single-block__row")}
            >
              <div
                className="date-input--input small-10 columns"
                style={getStyles("date-input--input")}
              >
                <Calendar
                  name="searchDateTo"
                  value={momentTo}
                  onChange={this.handleToDateChange}
                  placeholder={intl.formatMessage(
                    searchMessages.dateDDMMYYInclusive
                  )}
                />
              </div>
              <div
                className="date-input--action small-2 columns"
                style={getStyles("date-input--action")}
              >
                <button
                  type="button"
                  style={getStyles("date-input--action__button")}
                  className="button button--alert-subtle button--square-small"
                  onKeyPress={e =>
                    isKeyClick(e) ? this.handleDateToClear(e) : null
                  }
                  onClick={this.handleDateToClear}
                  title={intl.formatMessage(searchMessages.clearDate)}
                >
                  ×
                </button>
              </div>
            </div>
          </li>
        </ul>
      </AccordiItem>
    )
  }
}

export default injectIntl(FilterDate)



// WEBPACK FOOTER //
// ./webapp/components/elements/FilterDate.js